var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"reports"},[_c('div',{staticClass:"pageHeading"},[_c('h1',[_vm._v("Reporting")])]),_c('p',[_vm._v("Advanced Reporting Will Go Here")])])
}]

export { render, staticRenderFns }